import { type PaginationInput, getPaginationSkip } from '@pba/react-query';
import { useCallback } from 'react';
import type { FindUsersRequest } from '../../../services';
import type { UsersQueryFilter } from '../useGetUsers';

export const useGetUsersParameters = () =>
  useCallback(
    ({ filter, pagination }: { filter: UsersQueryFilter; pagination?: PaginationInput }): FindUsersRequest => {
      const { pageSize, skip } = getPaginationSkip({ pagination });

      return {
        // TODO: test this after backend is updated https://redmine.touch4it.com/issues/88278
        ...(filter.userIds?.length ? { _id: { $in: filter.userIds } } : {}),
        $limit: pageSize,
        $search: filter.search === '' ? undefined : filter.search,
        $skip: skip,
      };
    },
    [],
  );
